import { useEffect } from 'react';
import { getAppStoreLink } from '../../providers/AppLinkProvider';
import { appOpenUrl, openApp } from '../../util/openApp';

// Re-entry from Stripe, not a fresh download: reopen the Cost Estimator app
// and only fall back to the store listing when nothing handles it. The app's
// deep-link handler ignores paths it does not know, so this just brings it
// to the foreground — which is all that is needed: the payment-methods
// screen refreshes Stripe status on AppState 'active'.
const CE_APP_PATH = 'stripe-return';

const StripeConnectReturn = ({
    mode = 'return',
}: {
    mode?: 'return' | 'refresh';
}) => {
    const manualOpenUrl = appOpenUrl('costestimator', CE_APP_PATH);

    useEffect(
        () =>
            openApp('costestimator', CE_APP_PATH, {
                fallbackUrl: getAppStoreLink('costestimator'),
            }),
        []
    );

    const body =
        mode === 'refresh'
            ? 'This setup link expired — reopening SimplyWise to resume Stripe setup…'
            : 'Stripe setup complete — taking you back to SimplyWise…';

    return (
        <div
            style={{
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 24,
                textAlign: 'center',
                fontFamily: 'system-ui, -apple-system, sans-serif',
            }}
        >
            <p style={{ color: '#555', maxWidth: 360, marginBottom: 24 }}>
                {body}
            </p>
            <a
                href={manualOpenUrl}
                style={{
                    background: '#111',
                    color: '#fff',
                    padding: '12px 24px',
                    borderRadius: 8,
                    textDecoration: 'none',
                }}
            >
                Return to SimplyWise
            </a>
        </div>
    );
};

export default StripeConnectReturn;
